const tutorialSteps = {
	'add_singles_match': [
		{
			'text': "Welcome to the JoW Tutorial. I am the Mysterious Advisor and I am going to teach you how to run your wrestling company. Click <span class=\"tutorial-color\">Continue</span> or press <span class=\"tutorial-color\">enter</span> to continue.",
			'element': null,
			'action': null
		},
		{
			'text': "You're in charge of Ultimate Action Wrestling, a small but growing company looking to challenge the behemoth, Global Wrestling Federation, in the year 2003.",
			'element': null,
			'action': null
		},
		{
			'text': "Once you are done with the tutorial, you can keep playing this game with all the normal features. You can also exit the tutorial by clicking <span class=\"tutorial-color\">Menu</span> and come back to it later.",
			'element': '#main-menu-button', 'action': null
		},
		{
			'text': "Let's start with your dashboard. It contains alerts about your roster, upcoming events and staff tasks.",
			'element': '#dashboard-container',
			'action': null
		},
		{
			'text': "This is the card for your upcoming event. Booked matches and segments will show up here.",
			'element': '#event-card',
			'action': null
		},
		{
			'text': "Let's book a match. Click <span class=\"tutorial-color\">Book</span> to open the booking page.",
			'element': '#book-menu-button',
			'action': 'click_book_button'
		},
		{
			'text': "This is the match booking page, containing your singles roster.",
			'element': '#booking-container',
			'action': null
		},
		{
			'text': "We're going to book a match between our two top stars. Click on <span class=\"tutorial-color\">Ghost</span> (you might have to tap twice on mobile) to select him for booking.",
			'element': '.roster-item-member[data-name="Ghost"]', 'action': 'click_superstar_select'
		},
		{
			'text': "Here you can see this superstar's information, such as their popularity, workrate and charisma.",
			'element': '.superstar-information-container',
			'action': null
		},
		{
			'text': "A superstar's popularity determines their rank on your roster. Ghost's popularity is over 800 and he is a Main Eventer.",
			'element': '.superstar-info-popularity',
			'action': null
		},
		{
			'text': "Ghost also has a high workrate, which means he should perform well in a match.",
			'element': '.superstar-info-workrate',
			'action': null
		},
		{
			'text': "Click on <span class=\"tutorial-color\">Sean Hunt</span> to book these two in a match.",
			'element': '.roster-item-member[data-name="Sean Hunt"]',
			'action': 'add_singles_match'
		},
		{'text': "Great! This match is now on your event card.", 'element': '#matches', 'action': null}
	],
	'add_feud_to_match': [
		{
			'text': "Let's add a feud to this match. A feud is a rivalry or story that the superstars are involved in. Click <span class=\"tutorial-color\">Edit</span> and select <span class=\"tutorial-color\">Add Feud</span>.",
			'element': '.event-card-match-edit-menu .button-dropdown',
			'action': 'click_add_feud',
			'subElements': ['.event-card-match-add-feud-button']
		},
		{
			'text': "Let's select the <span class=\"tutorial-color\">Better Wrestler</span> feud.",
			'element': '.feud-item-container',
			'action': 'select_feud_item'
		},
		{
			'text': "This feud will now start when this match runs. There are other ways to start feuds that I'll go over later.",
			'element': '.match-feud-name',
			'action': null,
			'position': 'bottom'
		}
	],
	'add_tag_match': [
		{
			'text': "Click <span class=\"tutorial-color\">Tag Team</span> to open the teams roster.",
			'element': '#book-tag-team-menu-button',
			'action': 'click_tag_team_button'
		},
		{
			'text': "This time, we'll book more than 2 participants in the match, so click <span class=\"tutorial-color\">Multi</span> to enable multiple selections.",
			'element': '#multi-match-button',
			'action': 'click_multi_button'
		},
		{
			'text': "Let's book a match for the tag titles. Select <span class=\"tutorial-color\">Brothers of Sickness</span>.",
			'element': '.roster-item-member[data-name="Brothers of Sickness"]',
			'action': 'click_team_select'
		},
		{
			'text': "The team's information shows the average of its members' stats.",
			'element': '.superstar-information-container',
			'action': null
		},
		{
			'text': "Select <span class=\"tutorial-color\">The Foundation</span>, who are the champions.",
			'element': '.roster-item-member[data-name="The Foundation"]',
			'action': 'click_team_select'
		},
		{
			'text': "And select <span class=\"tutorial-color\">The Dirty Reeds</span>.",
			'element': '.roster-item-member[data-name="The Dirty Reeds"]',
			'action': 'click_team_select'
		},
		{
			'text': "Now click <span class=\"tutorial-color\">Book</span> to add this match.",
			'element': '#add-match-button',
			'action': 'add_tag_team_match',
			'position': 'bottom'
		},
		{'text': "This three-way match is now booked for the tag titles.", 'element': '#matches', 'action': null}
	],
	'play_first_event': [
		{
			'text': "Okay, it's time to run your first event! Click <span class=\"tutorial-color\">Play</span>.",
			'element': '#play-event',
			'action': 'click_play_event'
		},
		{
			'text': "This page contains the details of the match and its participants.",
			'element': '.match-container',
			'action': null
		},
		{
			'text': "<span class=\"tutorial-color\">Brothers of Sickness</span> are one of our top teams, so let's select them to win the match.",
			'element': '.match-wrestler[data-name="Brothers of Sickness"]',
			'action': 'click_match_wrestler'
		},
		{
			'text': "This is the result of the match, which shows attribute changes and the match rating. You can hover over items to see their details.",
			'element': '.match-result',
			'action': null
		},
		{
			'text': "It looks like Chris Gray suffered an injury, right as his team won the titles! Your staff will give you details about the injury after the event.",
			'element': '.updates-container',
			'action': null
		},
		{
			'text': "I don't think Brothers of Sickness can be the champions with one member injured, so let's vacate the titles.",
			'element': '.vacate-superstar-championships-button',
			'action': 'click_vacate_superstar_championships_button'
		},
		{
			'text': "The titles were vacated. Click <span class=\"tutorial-color\">Continue</span> to go to the next match.",
			'element': '#progress-segment-button',
			'action': 'click_match_continue'
		}
	],
	'simulate_match': [
		{
			'text': "For this match, let's simulate the winner. When simulating, the game will choose the winner for you. Click <span class=\"tutorial-color\">Simulate</span>.",
			'element': '#simulate-match', 'action': 'click_simulate_button', 'position': 'bottom', 'scrollTo': 'end'
		},
		{
			'text': "The Better Wrestler feud was started in this match. You can see the hype for this feud, marked by <i class=\"fa fa-bolt faded-red-light margin-left-2\"></i>. The higher the hype, the more fans it will attract.",
			'element': '.match-result-feuds',
			'action': null
		}
	],
	'end_first_event': [
		{
			'text': "Okay, click <span class=\"tutorial-color\">Continue</span> to end the event.",
			'element': '#progress-segment-button',
			'action': 'click_event_continue'
		},
		{
			'text': "After an event ends, you'll get some Creative Points based on the event's rating.",
			'element': '.event-results-points-change',
			'action': null
		},
		{
			'text': "Creative Points are used instead of money for most company actions, like signing talent, adding gimmick matches and hiring staff.",
			'element': '#points',
			'action': null
		},
		{
			'text': "Click <span class=\"tutorial-color\">Continue</span> to go to the next event.",
			'element': '#continue',
			'action': 'go_to_game'
		}
	],
	'view_messages': [
		{
			'text': "Your first event is over, so let's take a look at that injury. Click the messages icon.",
			'element': '#messages',
			'action': 'click_messages_button'
		},
		{
			'text': "This is your messages page. Here you'll find updates from your staff, messages from the owner and your superstars. Check it often.",
			'element': '#game-messages',
			'action': null
		},
		{
			'text': "Open up the injury message from your staff.",
			'element': '.message-preview-item:contains("Injury")',
			'action': 'click_injury_message'
		},
		{
			'text': "Okay, looks like Chris Gray is out for a while. We'll deal with that soon. You can read other messages if you want here, I'll wait.",
			'element': '#game-messages .message-content-container',
			'action': null
		}
	],
	'book_feud_segment': [
		{
			'text': "You're on a weekly show now. Let's start by booking a segment. A segment can be a promo or any other thing that is not a match. Click <span class=\"tutorial-color\">Book</span>.",
			'element': '#book-menu-button',
			'action': 'click_book_segment_button'
		},
		{'text': "This is the segment booking page.", 'element': '#booking-container', 'action': null},
		{
			'text': "Segment items show up here. These determine what kind of segment it will be.",
			'element': '#segment-items-container',
			'action': null,
			'scrollTo': 'start'
		},
		{
			'text': "Segment participants show up here. Currently it's showing feuds.",
			'element': '.participants-box-segment-container',
			'action': null
		},
		{
			'text': "Click on the <span class=\"tutorial-color\">Better Wrestler</span> feud to select its participants for the segment.",
			'element': '.feud-container',
			'action': 'click_segment_feud'
		},
		{
			'text': "We'll book these two in a <span class=\"tutorial-color\">Promo Ambush</span> segment.",
			'element': '.segment-item-container[data-name="Promo Ambush"]',
			'action': 'click_segment_item'
		},
		{
			'text': "Now click <span class=\"tutorial-color\">Book</span> to add this segment.",
			'element': '#add-segment',
			'action': 'add_segment'
		}
	],
	'book_singles_segment': [
		{
			'text': "Let's book another segment. Click <span class=\"tutorial-color\">Singles</span> to open the singles roster.",
			'element': '.book-segment-option:contains("Singles")',
			'action': 'click_segment_singles_button'
		},
		{
			'text': "Click on <span class=\"tutorial-color\">The Empress</span> to select her for the segment.",
			'element': '.roster-item-member[data-name="The Empress"]',
			'action': 'click_segment_superstar_select'
		},
		{
			'text': "The Empress has high charisma, which means she should perform well in a segment.",
			'element': '.superstar-info-charisma',
			'action': null
		},
		{
			'text': "Select the <span class=\"tutorial-color\">Backstage Interview</span> segment item.",
			'element': '.segment-item-container[data-name="Backstage Interview"]',
			'action': 'click_segment_item'
		},
		{
			'text': "Now click <span class=\"tutorial-color\">Book</span> to add this segment.",
			'element': '#add-segment',
			'action': 'add_segment'
		},
		{
			'text': "Good job! You can add a variety of segments for superstars and teams this way.",
			'element': '#matches',
			'action': null
		}
	],
	'view_superstar_details': [
		{
			'text': "Okay, let's deal with that injury. Click <span class=\"tutorial-color\">Manage</span>.",
			'element': '#manage',
			'action': 'click_manage_button'
		},
		{
			'text': "Click <span class=\"tutorial-color\">Roster</span> and select <span class=\"tutorial-color\">View</span>.",
			'element': '#manage-roster',
			'action': 'click_view_roster',
			'subElements': ['#view-roster-menu-button']
		},
		{
			'text': "This is your roster page containing details of all your superstars.",
			'element': '#roster-container',
			'action': null
		},
		{
			'text': "Click on <span class=\"tutorial-color\">Chris Gray</span> to open his details.",
			'element': '.roster-member:contains("Chris Gray")',
			'action': 'click_roster_superstar'
		},
		{
			'text': "This page contains all of the superstar's details.",
			'element': '#roster-member-details',
			'action': null
		},
		{
			'text': "This is your superstar's alignment, which can be Face, Heel or Neutral. This affects their matches and feuds. Faces generally do well against heels.",
			'element': '.roster-member-alignment',
			'action': null
		},
		{
			'text': "This is their appearances status, which can be full time or part time.",
			'element': '.roster-member-status',
			'action': null
		},
		{
			'text': "This is their overness, which determines how much the fans like them. Superstars can get over or become stale due to their overness.",
			'element': '.roster-member-overness',
			'action': null
		},
		{
			'text': "This is their morale. If this goes too low, they can get unhappy and potentially leave the company.",
			'element': '.roster-member-morale',
			'action': null
		},
		{
			'text': "These are their workrate and charisma stats. Superstars gain XP in their skills by performing and via training.",
			'element': '.roster-member-workrate-and-charisma',
			'action': null,
			'scrollTo': 'start'
		},
		{
			'text': "This is their gimmick, which can affect their overness.",
			'element': '.roster-member-gimmick-container',
			'action': null,
			'scrollTo': 'start'
		},
		{
			'text': "Superstars can have traits, each of which has a unique effect that you can see by hovering over it.",
			'element': '.roster-member-traits-container',
			'action': null,
			'scrollTo': 'start'
		},
		{
			'text': "These are your superstar's stats, from win/loss records to best matches. These are only available in <span class='gold'>JoW Paid</span>.",
			'element': '.roster-member-stats',
			'action': null,
			'scrollTo': 'start'
		},
		{
			'text': "Here you have actions you can perform on your superstar, from training, changing alignment to adding a gimmick or releasing them.",
			'element': '.roster-member-actions',
			'action': null,
			'scrollTo': 'start'
		}
	],
	'disband_team': [
		{
			'text': "Okay, let's add a new team for Brandon Gray. But first, we need to disband Brothers of Sickness. Click <span class=\"tutorial-color\">Roster</span> and select <span class=\"tutorial-color\">Teams</span>.",
			'element': '#manage-roster', 'action': 'click_view_teams', 'subElements': ['#view-teams-menu-button']
		},
		{
			'text': "This is your teams page containing details of all your tag teams and trios.",
			'element': '#view-teams-container',
			'action': null
		},
		{
			'text': "Click <span class=\"tutorial-color\">Brothers of Sickness</span> to open their details.",
			'element': '.view-teams-item:contains("Brothers of Sickness")',
			'action': 'click_view_teams_item'
		},
		{
			'text': "Here you can find all of the information for the team.",
			'element': '#roster-member-details',
			'action': null
		},
		{
			'text': "Click <span class=\"tutorial-color\">Disband</span> to disband this team.",
			'element': '.disband-team-button',
			'action': 'disband_team'
		}
	],
	'add_team': [
		{
			'text': "Now click <span class=\"tutorial-color\">Add</span> to add a new team.",
			'element': '#add-team-menu-button',
			'action': 'click_add_team_menu_button'
		},
		{
			'text': "Select <span class=\"tutorial-color\">Brandon Gray</span> as the first superstar.",
			'element': '.add-team-first-superstar-select',
			'action': 'select_team_first_superstar',
			'position': 'bottom'
		},
		{
			'text': "We're going to team him with <span class=\"tutorial-color\">Benjamin Dread</span>, who should be a good match for him.",
			'element': '.add-team-second-superstar-select',
			'action': 'select_team_second_superstar'
		},
		{'text': "Enter a name for the team.", 'element': '.add-team-name', 'action': null},
		{
			'text': "Now click <span class=\"tutorial-color\">Add</span>.",
			'element': '#add-team-button',
			'action': 'add_team',
			'position': 'bottom',
			'subElements': ['.add-team-name']
		},
		{
			'text': "Great, Brandon Gray is now ready to challenge for those vacated titles.",
			'element': '',
			'action': null
		}
	],
	'add_vacant_title_match': [
		{
			'text': "Click <span class=\"tutorial-color\">Book</span>.",
			'element': '#book-menu-button',
			'action': 'click_book_segment_button'
		},
		{
			'text': "Click <span class=\"tutorial-color\">Tag Team</span> to open the teams roster.",
			'element': '#book-tag-team-menu-button',
			'action': 'click_tag_team_button'
		},
		{
			'text': "Select the vacant tag titles. This will book them in the match.",
			'element': '.superstar-select.roster-item-championship',
			'action': 'click_title_select'
		},
		{'text': "Select the newly created team.", 'element': '.roster-item-member', 'action': 'click_team_select'},
		{
			'text': "And select <span class=\"tutorial-color\">The Foundation</span>, the former champions, to book them in a match.",
			'element': '.roster-item-member[data-name="The Foundation"]',
			'action': 'add_tag_team_match'
		},
		{'text': "This match is now booked for the vacant tag titles.", 'element': '#matches', 'action': null}
	],
	'add_gimmick_to_match': [
		{
			'text': "I feel like the match needs a gimmick. The titles are vacant. You thinking what I'm thinking? Click <span class=\"tutorial-color\">Edit</span> and select <span class=\"tutorial-color\">Add Gimmick</span>.",
			'element': '.event-card-match-edit-menu:last .button-dropdown',
			'action': 'click_add_gimmick',
			'subElements': ['.event-card-match-add-gimmick-button']
		},
		{
			'text': "Gimmick matches can boost match ratings but cost some Creative Points. Select <span class=\"tutorial-color\">Ladder</span> to open its details.",
			'element': '.gimmick-match-item[data-name="Ladder"]',
			'action': 'click_gimmick_match_item'
		},
		{
			'text': "Click <span class=\"tutorial-color\">Add Gimmick Match</span> to make this a ladder match.",
			'element': '.confirm-gimmick-match-for-match',
			'action': 'add_gimmick_to_match'
		},
		{
			'text': "You can perform a variety of other actions in the Edit menu, like deleting the match/segment, adding or removing a feud, removing a title to make a non-title match or selecting multiple titles.",
			'element': '.event-card-match-edit-menu:last .button-dropdown',
			'action': null
		}
	],
	'move_to_main_event': [
		{
			'text': "I think the title match should be in the main event, so let's move it up there.",
			'element': '#matches',
			'action': null
		},
		{
			'text': "Click and drag the title match to where the current main event is.",
			'element': '.event-match:last',
			'action': 'move_match_to_main_event',
			'position': 'bottom'
		},
		{'text': "There you go! You can rearrange match order like this.", 'element': '#matches', 'action': null}
	],
	'play_second_event': [
		{
			'text': "Okay, let's run this event. Click <span class=\"tutorial-color\">Play</span>.",
			'element': '#play-event',
			'action': 'click_play_event'
		},
		{
			'text': "This page contains the segment details. The segment is now running.",
			'element': '.match-container',
			'action': 'play_segment'
		},
		{'text': "Here you can see the result of the segment.", 'element': '#event-match-results', 'action': null},
		{
			'text': "Click <span class=\"tutorial-color\">Continue</span> to go to the next segment.",
			'element': '#progress-segment-button',
			'action': 'click_segment_continue'
		}
	],
	'play_second_event_second_segment': [
		{
			'text': "For some segments, you can select who performs the action. We'll have <span class=\"tutorial-color\">Sean Hunt</span> perform the attack, being the heel.",
			'element': '.match-wrestler:contains("Sean Hunt")', 'action': 'select_segment_winner', 'scrollTo': 'end'
		},
		{
			'text': "With the segment over, click <span class=\"tutorial-color\">Continue</span> to go to the main event.",
			'element': '#progress-segment-button',
			'action': 'click_segment_continue'
		}
	],
	'play_second_event_main_event': [
		{
			'text': "The title match is up next. Let's add an alternate finish to this match. Click <span class=\"tutorial-color\">Add Finish</span>.",
			'element': '.show-match-finishes-button',
			'action': 'click_add_finish_button',
			'position': 'bottom',
			'scrollTo': 'end'
		},
		{
			'text': "Select <span class=\"tutorial-color\">Cheating</span> as the finish.",
			'element': '.match-finishes-item-container:contains("Cheating")',
			'action': 'click_match_finish_item'
		},
		{
			'text': "Here are the details of this finish, such as whether it affects morale, its effect on rating and on popularity/overness changes.",
			'element': '.match-finishes-item-container.selected',
			'action': null,
			'scrollTo': 'start'
		},
		{
			'text': "Let's select the heels to win by cheating. Brandon Gray will have a longer road to recapturing the tag titles.",
			'element': '.match-wrestler[data-name="The Foundation"]',
			'action': 'click_match_wrestler'
		}
	],
	'end_second_event': [
		{
			'text': "Okay, they won by cheating. Click <span class=\"tutorial-color\">Continue</span> to end the event.",
			'element': '#progress-segment-button',
			'action': 'click_event_continue',
			'scrollTo': 'end'
		},
		{
			'text': "This page shows updates like injuries, morale changes and feuds started/ended.",
			'element': '#event-updates',
			'action': null,
			'scrollTo': 'start'
		},
		{
			'text': "This page shows your prestige changes. Most items, like segments, events and titles, have prestige that can be raised to provide benefits.",
			'element': '#prestige-results',
			'action': null,
			'scrollTo': 'start'
		},
		{
			'text': "Click <span class=\"tutorial-color\">Continue</span> to go to the post event.",
			'element': '#continue',
			'action': 'go_to_post_event'
		},
		{
			'text': "This page shows your viewership results. After weekly shows, you'll see how many viewers you and your competitors got, and event buys after monthly events. This feature is only available in <span class='gold'>JoW Paid</span>.",
			'element': '.viewership-results-box',
			'action': null
		},
		{
			'text': "Your viewership depends on your existing fans and the hype of your event. You can learn more about event hype by clicking <span class=\"tutorial-color\">Help</span> under <span class=\"tutorial-color\">About</span> in the main menu.",
			'element': '.user-company',
			'action': null
		},
		{
			'text': "Your fan change depends on your event's rating relative to your competitors'. ",
			'element': '.user-company .viewership-results-fan-change',
			'action': null
		},
		{
			'text': "Fans determine your company's reputation, which affects things like your roster size and the ability to buyout competitors.",
			'element': '#fans',
			'action': null
		},
		{
			'text': "Click <span class=\"tutorial-color\">Continue</span> to go to the next event.",
			'element': '#continue-viewership-results-button',
			'action': 'go_to_game',
			'scrollTo': 'end'
		}
	],
	'goals': [
		{
			'text': "Let's take a look at the event you just ran. Click <span class=\"tutorial-color\">Manage</span>.",
			'element': '#manage',
			'action': 'click_manage_button'
		},
		{
			'text': "Click <span class=\"tutorial-color\">Company</span> and select <span class=\"tutorial-color\">Events</span>.",
			'element': '#manage-company',
			'action': 'click_view_events',
			'subElements': ['#view-events-menu-button']
		},
		{
			'text': "This is the event history page. You can go through all your past events, view your calender and see competitors' events.",
			'element': '#event-history-container',
			'action': null
		},
		{
			'text': "Now let's see how you are doing against your competitors. Click <span class=\"tutorial-color\">Job</span> and select <span class=\"tutorial-color\">Fan History</span>.",
			'element': '#manage-job', 'action': 'click_view_fan_history', 'subElements': ['#view-fan-history-menu-button']
		},
		{
			'text': "This is the fan history page. You can see graphs of fans, viewers, buys and fan change here as you progress through the game.",
			'element': '.viewership-history-container',
			'action': null
		},
		{
			'text': "Let's take a look at your game's options.",
			'element': '#view-options-menu-button',
			'action': 'click_game_options'
		},
		{
			'text': "Here, you can change your game's settings, like the number of weekly shows to run.",
			'element': '#game-options-container',
			'action': null
		},
		{
			'text': "Each year, your owner will give you goals to complete. Let's take a look at them. Click <span class=\"tutorial-color\">Job</span> and select <span class=\"tutorial-color\">Goals</span>.",
			'element': '#manage-job', 'action': 'click_view_objectives', 'subElements': ['#view-objectives-menu-button']
		},
		{
			'text': "These are your goals for this year. Complete them to be rewarded with Creative Points. You'll also get a message from the owner about your goals.",
			'element': '#objectives-list',
			'action': null
		},
		{
			'text': "Your first goal is to make Johnny Knight a main eventer. You can do that by booking him to win until his popularity goes above 800.",
			'element': '.objective-item-container:contains("Johnny Knight")',
			'action': null
		},
	],
	'add_feud': [
		{
			'text': "Let's put Johnny Knight into a feud. Click <span class=\"tutorial-color\">Company</span> and select <span class=\"tutorial-color\">Feuds</span>.",
			'element': '#manage-company',
			'action': 'click_view_feuds_menu_button',
			'subElements': ['#view-feuds-menu-button']
		},
		{
			'text': "This is your feuds page. It shows your current, potential and past feuds, and allows you to create new feuds.",
			'element': '#feud-history-container',
			'action': null
		},
		{
			'text': "Click <span class=\"tutorial-color\">Add</span> to add a feud.",
			'element': '#create-feud-menu-button',
			'action': 'click_create_feud_menu_button'
		},
		{
			'text': "Select <span class=\"tutorial-color\">Johnny Knight</span> as the first superstar.",
			'element': '.create-feud-first-participant-select',
			'action': 'select_first_feud_superstar'
		},
		{
			'text': "We've got to put him against a top guy to get him to the main event, so select <span class=\"tutorial-color\">Joe Hammer</span> as the second superstar.",
			'element': '.create-feud-second-participant-select', 'action': 'select_second_feud_superstar'
		},
		{
			'text': "You can enter a custom name for your feud here. Enter anything you want e.g 'Betrayal'.",
			'element': '#create-feud-custom-name',
			'action': null,
			'scrollTo': 'start'
		},
		{
			'text': "Click on this feud item to select it.",
			'element': '.feud-item-container:eq(1)',
			'action': 'select_create_feud_item'
		},
		{
			'text': "Now click <span class=\"tutorial-color\">Create</span>.",
			'element': '#create-feud-button',
			'action': 'create_feud'
		},
		{
			'text': "A potential feud was created that you can start in a match or segment.",
			'element': '',
			'action': null
		},
		{
			'text': "Okay, let's go back.",
			'element': '#back-to-view-feuds-button',
			'action': 'click_view_feuds_menu_button'
		},
		{
			'text': "Select this feud to view its details.",
			'element': '.feud-history-item',
			'action': 'select_feud_history_item'
		},
		{
			'text': "Here you can view this feud's history, records and staleness. Feuds that go on too long with lose hype.",
			'element': '.feud-history',
			'action': null,
			'scrollTo': 'start'
		},
		{
			'text': "Click this feud to deselect it.",
			'element': '.feud-history-item',
			'action': 'unselect_feud_history_item'
		}
	],
	'view_indies': [
		{
			'text': "If you want to grow your company, you'll probably need to sign new talent. Let's check out the indies. Click <span class=\"tutorial-color\">Roster</span> and select <span class=\"tutorial-color\">Indies</span>.",
			'element': '#manage-roster',
			'action': 'click_view_indies_menu_button',
			'subElements': ['#view-indies-menu-button']
		},
		{
			'text': "This is the indies page. You can view and sign independent talent here.",
			'element': '#indie',
			'action': null
		},
		{
			'text': "These superstars are available to sign. You can recruit unavailable talent or wait for them to become available.",
			'element': '.available-indie',
			'action': null
		},
		{
			'text': "Click on this superstar to open their details.",
			'element': '.available-indie .roster-member',
			'action': 'click_indie_roster_member'
		},
		{
			'text': "The level of detail that you can see depends on the level of your scout.",
			'element': '#roster-member-details',
			'action': null
		},
		{
			'text': "You can click on <span class=\"tutorial-color\">Negotiate</span> to make an offer to this talent. We don't really have the money for that right now .. ",
			'element': '#start-negotiation-button', 'action': null, 'disallowClick': true, 'scrollTo': 'start'
		},
		{
			'text': "Anyway, let's take a look at how to sign a competitor's talent. Click <span class=\"tutorial-color\">Roster</span> and select <span class=\"tutorial-color\">View</span>.",
			'element': '#manage-roster', 'action': 'click_view_roster', 'subElements': ['#view-roster-menu-button']
		},
		{
			'text': "Select <span class=\"tutorial-color\">Global Wrestling Enterprise</span>.",
			'element': '.select-company-for-view-roster',
			'action': 'select_view_roster_company'
		},
		{
			'text': "Click on this superstar to open up their details.",
			'element': '.roster-member',
			'action': 'click_roster_superstar'
		},
		{
			'text': "You can click <span class=\"tutorial-color\">Negotiate</span> to make an offer, though talent signed to a company are more expensive than independent talent.",
			'element': '#start-negotiation-button', 'action': null, 'disallowClick': true, 'scrollTo': 'start'
		},
	],
	'view_staff_and_facilities': [
		{
			'text': "Remember I mentioned your scout? They are part of your staff, available in <span class='gold'>JoW Paid</span>. Click <span class=\"tutorial-color\">Staff</span> and select <span class=\"tutorial-color\">View</span>.",
			'element': '#manage-staff',
			'action': 'click_view_company_staff_menu_button',
			'subElements': ['#view-company-staff-menu-button']
		},
		{
			'text': "This is the staff page. It shows your hired staff for each role and their skill progress. You can hover over the roles to view more details. You'll also see a briefing from each staff member in your messages.",
			'element': '.company-staff-container', 'action': null
		},
		{
			'text': "Click on this staff member to view their details.",
			'element': '.company-staff-member',
			'action': 'click_staff_member'
		},
		{'text': "These are your staff member's details.", 'element': '.staff-member-details', 'action': null},
		{
			'text': "Okay, let's go back.",
			'element': '#back-to-staff-view-button',
			'action': 'click_back_to_staff_view_button'
		},
		{
			'text': "You can click <span class=\"tutorial-color\">Hire</span> to hire new staff members, though you can only have one staff member per role.",
			'element': '.company-staff-container .button:contains("Hire")',
			'action': null,
			'disallowClick': true
		},
		{
			'text': "Let's take a look at your company's facilities. Click <span class=\"tutorial-color\">Staff</span> and select <span class=\"tutorial-color\">Facilities</span>.",
			'element': '#manage-staff',
			'action': 'click_view_company_facilities_menu_button',
			'subElements': ['#view-company-facilities-menu-button']
		},
		{
			'text': "This is your company facilities page. It shows the level of your existing facilities and the requirements to upgrade them.",
			'element': '.company-facilities-container',
			'action': null
		}
	],
	'add_gimmick_match': [
		{
			'text': "Time to add some customization. Let's add a gimmick match. Click <span class=\"tutorial-color\">Company</span> and select <span class=\"tutorial-color\">Gimmick Matches</span>.",
			'element': '#manage-company',
			'action': 'click_view_gimmick_matches_menu_button',
			'subElements': ['#view-gimmick-matches-menu-button']
		},
		{'text': "This is your gimmick matches page.", 'element': '#view-gimmick-matches-container', 'action': null},
		{
			'text': "Click <span class=\"tutorial-color\">Add</span> to add a gimmick match.",
			'element': '#add-gimmick-match-menu-button',
			'action': 'click_add_gimmick_match_menu_button'
		},
		{
			'text': "You can customize your gimmick match, editing its name, match type, boost and consequence.",
			'element': '#add-gimmick-match',
			'action': null
		},
		{'text': "Enter a name for the gimmick match.", 'element': '.add-gimmick-match-name', 'action': null},
		{
			'text': "You can set a consequence for your gimmick match, like the loser becoming unavailable or the winner getting a championship match contract. Select <span class=\"tutorial-color\">Fixed Match Contract</span>.",
			'element': '.add-gimmick-match-consequence', 'action': 'select_gimmick_match_consequence'
		},
		{
			'text': "Fixed match contracts grant a title shot at a fixed event, while championship contracts grant a title shot that can be used anytime and can expire.",
			'element': '.add-gimmick-match-consequence',
			'action': null
		},
		{
			'text': "Add a name for this contract e.g 'Title Shot'.",
			'element': '.add-gimmick-match-match-contract-name',
			'action': null
		},
		{
			'text': "Now click <span class=\"tutorial-color\">Add</span>.",
			'element': '#add-gimmick-match-button',
			'action': 'add_gimmick_match',
			'position': 'bottom',
			'subElements': ['.add-gimmick-match-name', '.add-gimmick-match-match-contract-name']
		},
		{'text': "Good job! Your new gimmick match should be available while booking.", 'element': null, 'action': null}
	],
	'other_features': [
		{
			'text': "Under <span class=\"tutorial-color\">Company</span> you can also write your own segments (<span class=\"tutorial-color\">Segments</span> - <span class='gold'>JoW Paid</span>), edit titles (<span class=\"tutorial-color\">Titles</span>) " +
				"and view company stats (<span class=\"tutorial-color\">Stats</span>).",
			'element': '#manage-company',
			'action': null
		},
		{
			'text': "Under <span class=\"tutorial-color\">Roster</span> you also have the option to manage factions (<span class=\"tutorial-color\">Factions</span>) and make trades with your competitors (<span class=\"tutorial-color\">Trades</span>).",
			'element': '#manage-roster',
			'action': null
		},
		{
			'text': "Under <span class=\"tutorial-color\">Job</span> you can also see how well your competitors are doing (<span class=\"tutorial-color\">Companies</span>) and see your activity as a booker (<span class=\"tutorial-color\">Activity</span>).",
			'element': '#manage-job',
			'action': null
		},
		{
			'text': "There are a variety of other features to explore, like artifacts, which will be introduced after a month of playing. They allow you to perform special actions like bring back retired superstars.",
			'element': '#manage-other',
			'action': null
		},
		{
			'text': "You will also unlock Special Segments (<span class='gold'>JoW Paid</span>), which are unique segments with high bonuses, after four months.",
			'element': '#manage-other',
			'action': null
		},
		{
			'text': "There are many more features in JoW, like Tournaments, Random Events, Gimmicks, the Simulator and Stories. But I think you can discover them on your own.",
			'element': null,
			'action': null
		},
		{
			'text': "Before I go, let me tell you one way to book an end to a feud. Click <span class=\"tutorial-color\">Book</span>.",
			'element': '#book-menu-button',
			'action': 'click_book_segment_button'
		},
	],
	'book_feud_match': [
		{
			'text': "Click <span class=\"tutorial-color\">Singles</span>.",
			'element': '#book-singles-menu-button',
			'action': 'click_book_singles_feud_button'
		},
		{
			'text': "We're going to book the end to our top feud. Click on the <span class=\"tutorial-color\">Better Wrestler</span> to select its participants for the match.",
			'element': '.feud-container',
			'action': 'click_match_feud'
		},
		{
			'text': "Now click <span class=\"tutorial-color\">Book</span> to add this match.",
			'element': '#add-match-button',
			'action': 'add_singles_match',
			'position': 'bottom'
		}
	],
	'add_feud_blowoff': [
		{
			'text': "Click <span class=\"tutorial-color\">Add Blowoff</span> to end this feud after this match. The winner could move onto bigger things, perhaps challenging the champion, Eddie Dust?",
			'element': '.add-blowoff-to-feud',
			'action': 'add_feud_blowoff'
		},
		{
			'text': "You can also blowoff feuds using specific segments, or end them on the feuds page.",
			'element': '#matches',
			'action': null
		},
		{
			'text': "You've learned a lot and are already on your way towards becoming a master booker! If you have any questions, click <span class=\"tutorial-color\">Help</span> under <span class=\"tutorial-color\">About</span> " +
				"in the main menu or ask on the <a href='https://discord.gg/tjwJb99' target='_blank'>Discord</a>.",
			'element': null,
			'action': null
		},
		{
			'text': "I am also contractually obliged to mention that <a href='/jow-paid-features' target='_blank'>JoW Paid</a> adds a number of cool features like the ratings war, sandbox mode and company staff. " +
				"You can <a href='/free-trial' target='_blank'>try it</a> for free!", 'element': null, 'action': null
		},
		{
			'text': "I'm going to leave you to run the company yourself now. You can continue this game and make your own story for UAW or click <span class=\"tutorial-color\">Menu</span> to go back and choose a new game. I'll see you around.",
			'element': '#main-menu-button',
			'action': null
		}
	]
}

const tutorialStates = ['add_singles_match', 'add_feud_to_match', 'add_tag_match', 'play_first_event', 'simulate_match',
	'end_first_event', 'view_messages', 'book_feud_segment', 'book_singles_segment',
	'view_superstar_details', 'disband_team', 'add_team', 'add_vacant_title_match', 'add_gimmick_to_match',
	'move_to_main_event', 'play_second_event', 'play_second_event_second_segment',
	'play_second_event_main_event', 'end_second_event', 'goals', 'add_feud',
	'view_indies', 'view_staff_and_facilities', 'add_gimmick_match', 'other_features',
	'book_feud_match', 'add_feud_blowoff', 'end_tutorial'];

export {tutorialSteps, tutorialStates}